import { render } from "./EditSliderProductHome.vue?vue&type=template&id=1aec0294"
import script from "./EditSliderProductHome.vue?vue&type=script&lang=js"
export * from "./EditSliderProductHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__